<template>
<tbody>
  <tr v-for="(benda,index) in barang" :key=benda.id>
              <td>{{index+1}}</td>
              <td><img :src="benda.image_url" class="img"></td>
              <td>{{benda.name}}</td>
              <td>{{benda.price}}</td>
              <td>{{benda.stock}}</td>
              <td>
                  <button class="button is-success bot-btn" @click="editProductPage(benda.id,index)">
                <span class="icon is-small">
<i class="far fa-edit"></i>
                </span>
            </button>
            <button class="button is-danger bot-btn" @click="deleteProduct(benda.id,index)">
                <span class="icon is-small">
                     <i class="fas fa-trash-alt"></i>
                </span>
            </button>
              </td>
          </tr>
</tbody>
</template>

<script>
import axios from '../../axios.config'
export default {
  data () {
    return {

    }
  },
  methods: {
    fetchData () {
      this.$store.dispatch('fetchData')
    },
    deleteProduct (id,index) {
      let data = { id, index}
      this.$store.dispatch('deleteProduct',data)
    },
    editProductPage (id,index) {
      this.$store.dispatch('simpanEditIndex',index)
      this.$router.push({ name: 'EditProduct', params: { id } })
    }
  },
  computed: {
    barang () {
      return this.$store.state.barang
    }
  },
  created () {
    this.fetchData()
  }
}
</script>

<style>

</style>
